import React, { useState, useEffect } from 'react';
import './App.css';
import { translations } from './mock';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TaxCredit } from './components/TaxCredit';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [language, setLanguage] = useState('fr');
  const [serviceType, setServiceType] = useState('professional'); // Default to professional
  
  const t = { ...translations[language], language };

  // Smooth scroll function
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Add scroll reveal animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
      section.style.opacity = '0';
      section.style.transform = 'translateY(30px)';
      section.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header 
        t={t} 
        language={language} 
        onLanguageChange={setLanguage}
        onNavigate={scrollToSection}
      />
      
      <Hero 
        t={t} 
        onOpenContact={() => scrollToSection('contact')}
      />
      
      <TaxCredit 
        t={t}
        onOpenContact={() => scrollToSection('contact')}
      />
      
      <Services 
        t={t} 
        serviceType={serviceType}
        onServiceTypeChange={setServiceType}
      />
      
      <Process t={t} />
      
      <Testimonials t={t} />
      
      <FAQ t={t} />
      
      <Contact t={t} />
      
      <Footer t={t} />

      <Toaster position="top-right" />
    </div>
  );
}

export default App;
